import { commonRequestData, fetchData } from "../../api";

/**
 * Obtiene la lista de cotizaciones usando filtros y paginación server-side.
 *
 * @param {Object} query - Parámetros de búsqueda y paginación.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const obtenerLista_Cotizaciones = async (query = {}) => {
    const requestData = {
        ...commonRequestData,
        ...query,
    };

    return fetchData("cotizaciones/lista", requestData);
};

export const obtener_CotizacionId = async ({ idConsecutivo }) => {
    const requestData = {
        ...commonRequestData,
        idConsecutivo,
    };

    return fetchData("cotizaciones/obtenerCotizacion", requestData);
};

/**
 * Función para obtener la cotización por ID desde la API.
 *
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const obtener_NumeroConsecutivo = async () => {
    try {
        const requestData = {
            ...commonRequestData,
        };

        return await fetchData("cotizaciones/obtenerNumeroConsecutivo", requestData);
    } catch (error) {
        console.error("Error al obtener la cotización por ID:", error.message || error);
        throw new Error("No se pudo obtener la cotización. Verifique los detalles de la solicitud.");
    }
};

/**
 * Función para obtener los salones de un hotel desde la API.
 *
 * @param {Object} param0 - Contenedor del hotel.
 * @param {string|number} param0.idHotel - Hotel objetivo.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const obtenerSalonesSegunHotel = async ({ idHotel }) => {
    try {
        const requestData = {
            ...commonRequestData,
            idHotel,
        };

        return await fetchData("cotizaciones/obtenerSalonesSegunHotel", requestData);
    } catch (error) {
        console.error("Error al obtener los salones del hotel:", error.message || error);
        throw new Error("No se pudo obtener la lista de salones. Verifique los detalles de la solicitud.");
    }
};

/**
 * Función para crear una cotización utilizando la API.
 *
 * @param {Object} param0 - Datos de creación.
 * @param {Object} param0.datosCompletos - Payload completo de cotización.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const crearCotizacionApi = async ({ datosCompletos }) => {
    try {
        const requestData = {
            ...commonRequestData,
            datosCompletos,
        };

        return await fetchData("cotizaciones/crearCoticazion", requestData);
    } catch (error) {
        console.error("Error al crear la cotización:", error.message || error);
        throw new Error("No se pudo crear la cotización. Verifique los datos proporcionados.");
    }
};

/**
 * Obtiene una cotización puntual.
 *
 * @param {Object} param0 - Identificador solicitado.
 * @param {string|number} param0.id - ID interno.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const getCotizacionApi = async ({ id }) => {
    const requestData = {
        ...commonRequestData,
        id,
    };

    return fetchData("cotizaciones/obtenerCotizacionId", requestData);
};

/**
 * Elimina una cotización por ID.
 *
 * @param {Object} param0 - Identificador a eliminar.
 * @param {string|number} param0.id - ID interno.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const deleteEliminarCotizacion = async ({ id }) => {
    const requestData = {
        ...commonRequestData,
        id,
    };

    return fetchData("cotizaciones/eliminarCotizacion", requestData);
};

/**
 * Cambia estado de una cotización.
 *
 * @param {Object} param0 - Parámetros de actualización.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const cambioEstadoCotizacionApi = async ({ ids, estadosRelacionados, value, token }) => {
    const requestData = {
        ...commonRequestData,
        ids,
        estadosRelacionados,
        value,
        token,
    };

    return fetchData("cotizaciones/cambioEstadoCotizacionApi", requestData);
};

/**
 * Obtiene cotizaciones por cliente.
 *
 * @param {Object} param0 - Parámetros de búsqueda.
 * @param {string|number} param0.dato - ID cliente.
 * @returns {Promise<Object>} Respuesta completa de la API.
 */
export const obtener_CotizacionIdCliente = async ({ dato }) => {
    const requestData = {
        ...commonRequestData,
        dato,
    };

    return fetchData("cotizaciones/obtenerCotizacionCliente", requestData);
};
